import { createContext, type ReactNode, useContext, useState } from 'react'

const defaultFlags = {
  newBackend: import.meta.env.VITE_FF_NEW_BACKEND === 'true',
} as const

export type FeatureFlags = typeof defaultFlags
export type FlagName = keyof FeatureFlags

const FeatureFlagsContext = createContext<{
  flags: FeatureFlags
  setFlag: (name: FlagName, value: boolean) => void
}>({
  flags: defaultFlags,
  setFlag: () => {},
})

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
  const [flags, setFlags] = useState<FeatureFlags>(defaultFlags)

  const setFlag = (name: FlagName, value: boolean) => {
    setFlags((prev) => ({ ...prev, [name]: value }))
  }

  return (
    <FeatureFlagsContext.Provider value={{ flags, setFlag }}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext)
}

export function useFeatureFlag(name: FlagName): boolean {
  const { flags } = useFeatureFlags()
  return flags[name]
}
